module.exports = __webpack_public_path__ + "img/recommend_sp.656e1926.png";